const shows_friday = [

    {
        name: 'DJ AlexCool',
        shcedule: 'Friday 21:00',
        day: 5,
        time: 21,
        img: require('../../../img/weekly/friday21.png')
    },
    {
        name: 'DJ Shallx',
        shcedule: 'Friday 22:00',
        day: 5,
        time: 22,
        img: require('../../../img/weekly/friday22.png')
    },
    {
        name: 'Sdema',
        shcedule: 'Friday 23:00',
        day: 5,
        time: 22,
        img: require('../../../img/weekly/friday23.jpg')
    },
    {
        name: 'DJ Raiskiy',
        shcedule: 'Friday 20:00',
        day: 5,
        time: 20,
        img: require('../../../img/weekly/friday20.png')
    },
    {
        name: 'ENSARU',
        shcedule: 'Friday 19:00',
        day: 5,
        time: 19,
        img: require('../../../img/weekly/friday19.jpg')
    },
]

export default shows_friday;